/**
 * Recent documents for the File menu.
 *
 * macOS users look here the way browser users look at a tab strip. Ten is
 * enough to cover a week's preaching without turning the menu into a library.
 */

export interface RecentDocument {
  id: number;
  title: string;
  openedAt: number;
}

const KEY = "sermonspace:recent-documents";
const LEGACY_KEY = "writerspace:recent-documents";
const LIMIT = 10;
const listeners = new Set<() => void>();

function read(): RecentDocument[] {
  try {
    const raw = localStorage.getItem(KEY) ?? localStorage.getItem(LEGACY_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as RecentDocument[];
    return Array.isArray(parsed) ? parsed.filter((item) => item && typeof item.id === "number") : [];
  } catch {
    return [];
  }
}

function write(items: RecentDocument[]) {
  localStorage.setItem(KEY, JSON.stringify(items.slice(0, LIMIT)));
  for (const listener of listeners) listener();
}

export function getRecentDocuments(): RecentDocument[] {
  return read();
}

export function recordRecentDocument(id: number, title: string) {
  const label = title.trim() || "Untitled";
  const current = read();
  if (current[0]?.id === id && current[0]?.title === label) return;
  write([
    { id, title: label, openedAt: Date.now() },
    ...current.filter((item) => item.id !== id),
  ]);
}

export function subscribeRecentDocuments(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
